import { render, staticRenderFns } from "./ServiceOrderSubletComponent.vue?vue&type=template&id=71baafe9&"
import script from "./ServiceOrderSubletComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderSubletComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports